import { useEffect, useCallback, useState } from 'react';
import { wsClient } from './WebSocketClient';

/**
 * Hook to manage WebSocket connection lifecycle.
 * Only connects when a tenantUuid is provided; disconnects when it becomes falsy.
 */
export function useWebSocketConnection(tenantUuid?: string | null) {
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!tenantUuid) return;

    const handleConnect = () => {
      setIsConnected(true);
      setError(null);
    };

    const handleDisconnect = () => {
      setIsConnected(false);
    };

    const handleError = (err: Error) => {
      setError(err);
    };

    wsClient.on('connect', handleConnect);
    wsClient.on('disconnect', handleDisconnect);
    wsClient.on('error', handleError);

    wsClient.connect();

    return () => {
      wsClient.off('connect', handleConnect);
      wsClient.off('disconnect', handleDisconnect);
      wsClient.off('error', handleError);
      wsClient.disconnect();
    };
  }, [tenantUuid]);

  const reconnect = useCallback(() => {
    wsClient.disconnect();
    wsClient.connect();
  }, []);

  return { isConnected, error, reconnect };
}
